import React from "react";
import { useTranslation } from 'react-i18next'

const Hellosection = ({whatsection}) => {
  const { t, i18n } = useTranslation()

  return (
    <section className="cfan-imagewith-text">
        <div className="container">
            <div className="image-width-wrapper d-flex align-items-start">
                <div className="cfan-text">
                    <p>{whatsection.textone}</p>
                </div>
                <div className="cfan-image">
                    <img src={whatsection.img} alt=""/>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Hellosection;